const PROJECT_ID = "k11iw1kj";
export default {
  PROJECT_ID,
};
